import { FC } from "react";
import { Link } from "react-router-dom";
import { ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { CONCEIVE_SUPPORT_EMAIL, routes, sharedProps } from "~/constants";

const linkProps = {
  as: "a" as const,
  target: "_blank" as const,
  ...sharedProps.link.hover,
  px: 0,
};

const CoachApplication = (
  <Text {...linkProps} href={`mailto:${CONCEIVE_SUPPORT_EMAIL}`} />
);
const Email = <Text {...linkProps} href={`mailto:${CONCEIVE_SUPPORT_EMAIL}`} />;
const Hello = <Text {...linkProps} href="mailto:hello@weconceive.com" />;
const HowItWorks = (
  <Text {...linkProps} as={Link} target="_self" to={routes.howItWorks} />
);
const ProviderApplication = (
  <Text {...linkProps} href={`mailto:${CONCEIVE_SUPPORT_EMAIL}`} />
);
const SettingsLink = (
  <Text {...linkProps} as={Link} target="_self" to={routes.settings} />
);

const BaseResponseTimeQuestion: FC = () => {
  return (
    <>
      <Text mb={4}>
        You can expect the below response times based on the time of day
      </Text>

      <UnorderedList mb={4} spacing={4}>
        <ListItem>
          <Text as="span" mb={1}>
            Weekdays:
          </Text>
          <UnorderedList spacing={1}>
            <ListItem>9am-6pm: 20 minutes.</ListItem>
            <ListItem>6-10pm: 1 hour</ListItem>
            <ListItem>Overnight: by the next morning at 9am</ListItem>
          </UnorderedList>
        </ListItem>

        <ListItem>
          <Text as="span" mb={1}>
            Weekend:
          </Text>
          <UnorderedList spacing={1}>
            <ListItem>9am-6pm: 30 minutes</ListItem>
            <ListItem>6-10pm: 2 hours</ListItem>
            <ListItem>Overnight: by the next morning at 9am</ListItem>
          </UnorderedList>
        </ListItem>

        <ListItem>
          <Text as="span" mb={1}>
            Holidays: by 9am the day after the holiday
          </Text>
        </ListItem>
      </UnorderedList>

      <Text mb={4}>
        If you are in a crisis, please use the below resources to get help
        immediately.
      </Text>

      <UnorderedList spacing={1}>
        <ListItem>911 - Emergency</ListItem>
        <ListItem>988 - National Suicide Prevention Lifeline</ListItem>
        <ListItem>741741 - Crisis text line</ListItem>
      </UnorderedList>
    </>
  );
};

const ResponseTimeQuestion = <BaseResponseTimeQuestion />;

export const components = {
  CoachApplication,
  Email,
  Hello,
  HowItWorks,
  ProviderApplication,
  ResponseTimeQuestion,
  SettingsLink,
};
